export enum LOGO_THEME {
    BLACK = 'black',
    WHITE = 'white',
}
